import React from "react";
import style from "./Tooltip.module.scss";

const Tooltip = ({ text, children }) => (
  <div className={style.tooltip} tooltip={text} tooltip-position="top">
    {children}
  </div>
);

export default Tooltip;
